// src/components/HomePage/AllTools.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const TOOLS_CONFIG = [
  {
    id: 'rcon',
    category: 'audit',
    name: 'RCON Аудит',
    desc: 'Сканирование открытых портов RCON и анализ надежности парольной аутентификации.',
    hint: 'Порты 25575 / 25565 • Нажмите для запуска',
    path: '/rcon-audit',
    colSpan: 'lg:col-span-6',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="4 17 10 11 4 5" />
        <line x1="12" y1="19" x2="20" y2="19" />
      </svg>
    )
  },
  {
    id: 'data',
    category: 'audit',
    name: 'Извлечение Данных',
    desc: 'Получение открытых данных: MOTD, списки игроков, установленные плагины и параметры протокола.',
    hint: 'JSON / RAW экспорт метаданных',
    path: '/server-data-extraction',
    colSpan: 'lg:col-span-6',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
    )
  },
  {
    id: 'zeroday',
    category: 'audit',
    name: 'Zero-day метод',
    desc: 'Передовой алгоритм глубокого анализа логики сетевых пакетов ядра для выявления критических уязвимостей до их публичного раскрытия.',
    hint: 'Нажмите для активации алгоритма',
    path: '/secret',
    colSpan: 'lg:col-span-12',
    isZeroDay: true,
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current stroke-none">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    )
  },
  {
    id: 'ddos',
    category: 'stress',
    name: 'DDoS Тестирование',
    desc: 'Оценка стрессоустойчивости инфраструктуры к сетевым нагрузкам на уровнях L4 и L7.',
    hint: 'TCP / UDP анализ канала',
    path: '/ddos',
    colSpan: 'lg:col-span-4',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
      </svg>
    )
  },
  {
    id: 'op',
    category: 'audit',
    name: 'OP Бот',
    desc: 'Проверка правильности разграничения прав доступа и привилегий оператора.',
    hint: 'Permissions & ACL аудит',
    path: '/bots?type=op',
    colSpan: 'lg:col-span-4',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    )
  },
  {
    id: 'crash',
    category: 'stress',
    name: 'Краш Бот',
    desc: 'Проверка устойчивости тикрейта (TPS) сервера к аномальным последовательностям пакетов.',
    hint: 'Тест обработки чанков',
    path: '/bots?type=crash',
    colSpan: 'lg:col-span-4',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    )
  },
  {
    id: 'acc_checker',
    category: 'db',
    name: 'Проверка Аккаунтов',
    desc: 'Поиск информации о скомпрометированных учётных записях в локальной базе данных.',
    hint: 'База данных 153K записей',
    path: '/account-checker',
    colSpan: 'lg:col-span-6',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    )
  },
  {
    id: 'acc_bot',
    category: 'db',
    name: 'Аккаунт Бот',
    desc: 'Анализ стойкости алгоритмов авторизации AuthMe и nLogin против словарных атак.',
    hint: 'Проверка задержки авторизации',
    path: '/bots?type=account',
    colSpan: 'lg:col-span-6',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 stroke-current fill-none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    )
  }
];

const AllTools = () => {
  const { t } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredTools = TOOLS_CONFIG.filter(tool => {
    if (activeCategory === 'all') return true;
    return tool.category === activeCategory;
  });

  return (
    <section className="mb-12 sm:mb-20" id="toolsSection">
      {/* Section Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 pb-4 mb-5 sm:mb-6 border-b border-white/[0.15] px-1.5 sm:px-1">
        <div className="flex flex-col gap-1">
          <h2 className="text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
            {t('allTools') || 'Наши инструменты'}
          </h2>
          <span className="text-xs sm:text-base text-white/80 font-normal">
            Модули аудита инфраструктуры, анализа сетевых служб и стресс-тестирования
          </span>
        </div>

        {/* Filter Pills */}
        <div className="flex items-center gap-1.5 p-1 rounded-full bg-[#11131a] border border-white/[0.08] overflow-x-auto scrollbar-hide max-w-full touch-pan-x shrink-0 -ml-1.5 sm:ml-0 self-start">
          {[
            { id: 'all', label: 'Все модули' },
            { id: 'audit', label: 'Аудит & Эксплойты' },
            { id: 'stress', label: 'Стресс-тесты' },
            { id: 'db', label: 'Базы данных' }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveCategory(tab.id)}
              className={`px-3 sm:px-4 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all duration-200 ${
                activeCategory === tab.id
                  ? 'bg-white text-black font-bold shadow-[0_2px_10px_rgba(255,255,255,0.12)]'
                  : 'text-white/75 hover:text-white hover:bg-white/[0.06]'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* 12-Column Responsive Tools Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-3.5 sm:gap-[18px]">
        {filteredTools.map((tool) => (
          <Link
            to={tool.path}
            key={tool.id}
            className={`rounded-[20px] sm:rounded-[22px] p-5 sm:p-[28px_30px] flex flex-col justify-between group ${tool.colSpan} ${
              tool.isZeroDay
                ? 'border border-[rgba(192,38,211,0.45)] hover:border-[#c026d3] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.9)] hover:shadow-[0_24px_55px_-10px_rgba(0,0,0,0.95)]'
                : 'border border-white/[0.08] hover:border-white bg-[#111319] hover:bg-[#161922] shadow-[0_4px_18px_rgba(0,0,0,0.3)] hover:shadow-[0_16px_36px_-8px_rgba(0,0,0,0.85)]'
            } hover:-translate-y-1 active:scale-[0.985] transform-gpu will-change-transform`}
            style={{
              background: tool.isZeroDay
                ? 'linear-gradient(135deg, rgba(192, 38, 211, 0.12) 0%, #111319 65%)'
                : undefined,
              transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.25s ease, box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1), background-color 0.25s ease'
            }}
          >
            <div>
              {/* Icon Box */}
              <div className="flex items-center justify-between mb-3.5 sm:mb-[18px]">
                <div
                  className={`w-10 h-10 sm:w-12 sm:h-12 rounded-[12px] sm:rounded-[14px] ${
                    tool.isZeroDay
                      ? 'bg-[rgba(192,38,211,0.14)] border border-[rgba(192,38,211,0.35)] text-[#f0abfc]'
                      : 'bg-white/[0.05] border border-white/[0.12] text-white'
                  } flex items-center justify-center shadow-[0_2px_10px_rgba(0,0,0,0.4)] transition-all duration-250 [&_svg]:w-5 [&_svg]:h-5 sm:[&_svg]:w-6 sm:[&_svg]:h-6`}
                >
                  {tool.icon}
                </div>
              </div>

              {/* Title & Desc */}
              <div className="mb-4 sm:mb-[22px]">
                <h3 className={`font-extrabold tracking-[-0.01em] text-white mb-1.5 sm:mb-2 ${tool.isZeroDay ? 'text-xl sm:text-[1.7rem]' : 'text-lg sm:text-[1.4rem]'}`}>
                  {tool.name}
                </h3>
                <p className={`text-[#f5f5f7] leading-[1.55] sm:leading-[1.6] font-normal text-xs sm:text-[0.95rem] ${tool.isZeroDay ? 'max-w-4xl text-sm sm:text-base' : ''}`}>
                  {tool.desc}
                </p>
              </div>
            </div>

            {/* Footer Hint */}
            <div className="pt-3.5 border-t border-white/10 flex items-center justify-between text-xs text-white/60 font-semibold">
              <span className={tool.isZeroDay ? 'text-[#f0abfc] font-bold' : ''}>{tool.hint}</span>
              <div
                className="w-7 h-7 rounded-full bg-[#181b24] text-white/60 group-hover:text-white flex items-center justify-center group-hover:translate-x-[3px] shrink-0 ml-2 shadow-[0_2px_6px_rgba(0,0,0,0.3)]"
                style={{ transition: 'all 0.25s ease' }}
              >
                <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 stroke-current fill-none" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default AllTools;